import { GsFormField, GsFormIf, GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { borderRadiusSchemaFields } from './../basics/border.schema';
import { pictureDisplayModeSchemaFor } from './../basics/picture-display-mode.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Grouping of all media related fields */
const MEDIA_GROUP = 'components.chainstoreDetail.schema.media';

/** Condition: the picture settings only matter when the picture is shown */
const SHOW_PICTURE_IF: GsFormIf = { args: [{ formControlName: 'showPicture', value: true }] };

/**
 * The schema for the chainstore detail component form.
 * Defines the fields to display for the form.
 */
export const CHAINSTORE_DETAIL_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'showPicture',
      label: 'components.chainstoreDetail.schema.showPicture',
      type: 'checkbox',
      default: true,
      groupingName: MEDIA_GROUP
    },
    ...borderRadiusSchemaFields('', undefined, MEDIA_GROUP, SHOW_PICTURE_IF, 'schema.imageRadius'),
    {
      formControlName: 'imageHeight',
      label: 'components.chainstoreDetail.schema.imageHeight',
      type: 'number',
      isResponsive: true,
      nullable: true,
      groupingName: MEDIA_GROUP,
      if: SHOW_PICTURE_IF
    },
    {
      ...pictureDisplayModeSchemaFor('pictureDisplayMode', undefined, undefined, MEDIA_GROUP),
      if: SHOW_PICTURE_IF
    } as GsFormField<never>,
    {
      formControlName: 'showContactDetails',
      label: 'components.chainstoreDetail.schema.showContactDetails',
      type: 'checkbox',
      default: true,
      groupingName: 'components.chainstoreDetail.schema.contactDetails'
    },
    {
      formControlName: 'showAddress',
      label: 'components.chainstoreDetail.schema.showAddress',
      type: 'checkbox',
      default: true,
      groupingName: 'components.chainstoreDetail.schema.contactDetails',
      if: {
        args: [{ formControlName: 'showContactDetails', value: true }]
      }
    },
    {
      formControlName: 'showPhone',
      label: 'components.chainstoreDetail.schema.showPhone',
      type: 'checkbox',
      default: true,
      groupingName: 'components.chainstoreDetail.schema.contactDetails',
      if: {
        args: [{ formControlName: 'showContactDetails', value: true }]
      }
    },
    {
      formControlName: 'showEmail',
      label: 'components.chainstoreDetail.schema.showEmail',
      type: 'checkbox',
      default: true,
      groupingName: 'components.chainstoreDetail.schema.contactDetails',
      if: {
        args: [{ formControlName: 'showContactDetails', value: true }]
      }
    },
    {
      formControlName: 'showWebSite',
      label: 'components.chainstoreDetail.schema.showWebSite',
      type: 'checkbox',
      default: true,
      groupingName: 'components.chainstoreDetail.schema.contactDetails',
      if: {
        args: [{ formControlName: 'showContactDetails', value: true }]
      }
    },
    {
      formControlName: 'showSocialMedia',
      label: 'components.chainstoreDetail.schema.showSocialMedia',
      type: 'checkbox',
      default: false,
      groupingName: 'components.chainstoreDetail.schema.contactDetails',
      if: {
        args: [{ formControlName: 'showContactDetails', value: true }]
      }
    },
    {
      formControlName: 'showOpeningHours',
      label: 'components.chainstoreDetail.schema.showOpeningHours',
      type: 'checkbox',
      default: true,
      groupingName: 'components.chainstoreDetail.schema.openingHours'
    },
    {
      formControlName: 'showMap',
      label: 'components.chainstoreDetail.schema.showMap',
      type: 'checkbox',
      default: true,
      groupingName: 'components.chainstoreDetail.schema.map'
    },
    {
      formControlName: 'showContactForm',
      label: 'components.chainstoreDetail.schema.showContactForm',
      type: 'checkbox',
      default: false,
      groupingName: 'components.chainstoreDetail.schema.contactForm'
    }
  ]
};
